import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router) { }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    httpRequest = httpRequest.clone({
      withCredentials: true
    });
    /* if (httpRequest && (httpRequest.url.indexOf('localhost') > -1 || httpRequest.url.indexOf('loca.lt') > -1)) {
      httpRequest = httpRequest.clone({
        withCredentials: true
      });
    } */

    return next.handle(httpRequest).pipe(catchError(this.handleError));
  }

  handleError = (error: HttpErrorResponse) => {
    if (error.status === 401) {
      //this.authService.logout();
      this.router.navigate(['login']);
      return throwError('Unauthorized!');
    } else {
      return throwError(error);
    }
  };
}
